import { ExamType, GenericExamLevel } from '../api/candidate/exam/model';
import { ApiPathParam } from '../models/SearchParamSchema';
import { formAPIPageable, formAPIPageWithoutSort, formAPIToken } from '../utils/StringUtils';
import { Type } from '../api-refactored/candidate/useGetWorkPassTypes';
// =============================================================================
// User
// =============================================================================

const USER_BASE_URL = '/user/api';

export const POST_LOGIN_URL = `${USER_BASE_URL}/signin`;
export const POST_LOGOUT_URL = `${USER_BASE_URL}/signout`;
export const GET_USER_DETAILS_URL = `${USER_BASE_URL}/user-details`;

export const GET_OTP_DETAILS_URL = `${USER_BASE_URL}/otp/details`;
export const POST_GENERATE_OTP_URL = `${USER_BASE_URL}/otp/generate`;
export const POST_VERIFY_OTP_URL = `${USER_BASE_URL}/otp/verify`;

export const GET_USER_AUTHORITIES_URL = `${USER_BASE_URL}/granted-authorities`;
export const GET_USER_GRANTED_ACCESS_URL = (functionName: string) =>
  `${USER_BASE_URL}/admin/granted-accesses/${functionName}`;

export const POST_FORGOT_PASSWORD_LINK_GENERATION_URL = `${USER_BASE_URL}/password/generate-link`;
export const POST_RESET_PASSWORD_URL = `${USER_BASE_URL}/password/reset`;
export const POST_RESET_PASSWORD_FROM_ADMIN_URL = `${USER_BASE_URL}/admin/generate-password-link`;
export const GET_RESET_LINK_VALIDITY = `${USER_BASE_URL}/password/verify-link`;
export const PUT_CHANGE_PASSWORD = `${USER_BASE_URL}/password/change`;

export const GET_ACTION_REQUEST_LIST_URL = `${USER_BASE_URL}/admin/actions`;
export const POST_APPROVE_REQUEST_URL = (id: number) =>
  `${USER_BASE_URL}/admin/tasks/${id}/approve`;
export const POST_REJECT_REQUEST_URL = (id: number) => `${USER_BASE_URL}/admin/tasks/${id}/reject`;
export const POST_CANCEL_REQUEST_URL = (id: number) =>
  `${USER_BASE_URL}/admin/requester/tasks/${id}/cancel`;

export const GET_ACTION_TYPES_URL = `${USER_BASE_URL}/admin/types`;
export const GET_ACCOUNT_ACTION_TYPES_URL = `${USER_BASE_URL}/admin/actiontypes`;
export const GET_OPS_ADMIN_ACCOUNT_ACTION_TYPES_URL = `${USER_BASE_URL}/admin/ops-admins/action-types`;

export const GET_SINGPASS_CONSENT_URL = `${USER_BASE_URL}/sp/auth/url`;
export const POST_SINGPASS_TOKEN_URL = `${USER_BASE_URL}/sp/exchange-token`;
export const POST_SINGPASS_CALLBACK_URL = `${USER_BASE_URL}/sp/consent/callback`;
export const GET_SINGPASS_AUTH_JWKS = `/.well-known/keys`;
export const POST_MYINFO_TOKEN_URL = `${USER_BASE_URL}/mi/exchange-token`;
export const GET_MIMS_AUTH_URL = `${USER_BASE_URL}/mims/authz`;
export const POST_MIMS_CALLBACK_URL = `${USER_BASE_URL}/mims/consent/callback`;

export const POST_CREATE_COORDINATOR_URL = `${USER_BASE_URL}/users/coordinators`;
export const POST_CREATE_CANDIDATE_URL = `${USER_BASE_URL}/users/candidates`;

export const POST_ACCOUNT_ACTIVATION_URL = `${USER_BASE_URL}/activation-validation`;
export const POST_SET_PASSWORD_URL = `${USER_BASE_URL}/activation`;

export const GET_USER_LIST_URL = `${USER_BASE_URL}/users`;
export const GET_USER_GROUP_URL = `${USER_BASE_URL}/admin/roles`;

export const GET_IEXAM2_DETAILS_URL = `${USER_BASE_URL}/iexam2-details`;
export const GET_APPROVERS_URL = `${USER_BASE_URL}/admin/approvers`;

export const POST_BLOCK_USER_URL = `${USER_BASE_URL}/admin/block`;
export const POST_UNBLOCK_USER_URL = `${USER_BASE_URL}/admin/unblock`;
export const POST_UNLOCK_USER_URL = `${USER_BASE_URL}/admin/unlock`;

export const PUT_EDIT_OPS_ADMIN_URL = (id: number) => `${USER_BASE_URL}/admin/ops-admins/${id}`;
export const DELETE_OPS_ADMIN_URL = (id: number) => `${USER_BASE_URL}/admin/ops-admins/${id}`;

export const GET_ORGANISATIONS_LIST_URL = `${USER_BASE_URL}/organisations`;
export const GET_REGISTRATION_ORGANISATIONS_LIST_URL = `${USER_BASE_URL}/registration/admin/organisations`;

export const GET_USER_SETTINGS_URL = `${USER_BASE_URL}/settings`;
export const PUT_USER_SETTINGS_URL = `${USER_BASE_URL}/settings`;

export const GET_ACCESS_CONFIG_URL = (targetGroup: string) =>
  `${USER_BASE_URL}/access/${targetGroup}`;
export const POST_UDPATE_ACCESS_CONFIG_URL = `${USER_BASE_URL}/access`;

export const GET_ACCESS_ROLE_URL = `${USER_BASE_URL}/admin/roles/format`;
export const PUT_UPDATE_ACCESS_ROLE_URL = `${USER_BASE_URL}/admin/roles/authority`;

export const GET_CANDIDATE_URL = (userIndex: number) => `${USER_BASE_URL}/candidates/${userIndex}`;
export const GET_COORDINATOR_URL = (userIndex: number) =>
  `${USER_BASE_URL}/coordinators/${userIndex}`;
export const GET_OPS_ADMIN_URL = (userIndex: number) =>
  `${USER_BASE_URL}/admin/ops-admins/${userIndex}`;

export const POST_CANDIDATE_SEARCH_URL = `${USER_BASE_URL}/account`;

export const POST_PUT_ADMIN_PROFILE_DETAIL_URL = `${USER_BASE_URL}/administrator`;

export const GET_ADMIN_PROFILE_DETAIL_URL = `${USER_BASE_URL}/administrator`;

export const POST_CANDIDATE_SEARCH_NO_PAGINATION_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${USER_BASE_URL}/candidates/search${tparams}`;
};

export const POST_COORDINATOR_SEARCH_NO_PAGINATION_URL = `${USER_BASE_URL}/coordinators/search`;

export const POST_OPS_ADMIN_SEARCH_URL = (page: number | undefined, size: number | undefined) =>
  `${USER_BASE_URL}/admin/admins/search?page=${page}&size=${size}`;

export const GET_CANDIDATE_PROFILE_DETAILS_URL = `${USER_BASE_URL}/candidates`;
export const PUT_UPDATE_CANDIDATE_PROFILE_DETAILS_URL = `${USER_BASE_URL}/candidates`;

export const POST_AUDIT_VIEW_PROFILE_URL = `${USER_BASE_URL}/audit/view-profile`;
export const GET_AUDIT_ELIGIBILITY_URL = `${USER_BASE_URL}/admin/audit-transaction/eligibility`;

export const GET_COORDINATOR_PROFILE_URL = `${USER_BASE_URL}/coordinators`;
export const PUT_UPDATE_COORDINATOR_PROFILE_URL = `${USER_BASE_URL}/coordinators`;

export const GET_CAPTCHA_SITE_KEY_URL = `${USER_BASE_URL}/captcha/site-key`;
export const POST_CAPTCHA_VERIFY_TOKEN_URL = `${USER_BASE_URL}/captcha/verify-token`;

export const GET_SCHOOLS_BY_TYPE_URL = (type: string) =>
  `${USER_BASE_URL}/organisations/schools/${type}`;

export const GET_ORGANISATIONS_URL = `${USER_BASE_URL}/admin/organisations`;

export const POST_RETRIEVE_USERNAME_BY_EMAIL_URL = `${USER_BASE_URL}/user/forgot-username`;

export const PUT_REQUEST_PROFILE_AMENDMENT_URL = `${USER_BASE_URL}/candidates/request-amendment`;

export const PUT_UPDATE_PROFILE_AMENDMENT_REQUEST_STATUS_URL = (uuid: string) =>
  `${USER_BASE_URL}/admin/profile-amendment-requests/${uuid}`;

export const POST_PROFILE_AMENDMENT_REQUESTS_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${USER_BASE_URL}/admin/profile-amendment-requests/search${tparams}`;
};

export const GET_PROFILE_AMENDMENT_REQUESTS_URL = `${USER_BASE_URL}/profile-amendment-requests`;

export const PUT_CANCEL_PROFILE_AMENDMENT_REQUEST_URL = (uuid: string) =>
  `${USER_BASE_URL}/admin/profile-amendment-requests/${uuid}`;

export const POST_GENERATE_PRESIGNED_URL_FOR_UPLOADING_PROFILE_AMENDMENT_REQUEST_FILES_URL = `${USER_BASE_URL}/candidate/profile-amendment-files`;

export const GET_PROFILE_AMENDMENT_REQUEST_FILTER_URL = `${USER_BASE_URL}/admin/profile-amendment-request-filters`;
export const GET_PROFILE_AMENDMENT_REQUEST_STATUSES_URL = `${USER_BASE_URL}/admin/profile-amendment-request-statuses`;
export const GET_PROFILE_AMENDMENT_REQUEST_DETAILS_URL = (uuid: string) =>
  `${USER_BASE_URL}/admin/profile-amendment-requests/${uuid}`;
export const GET_PROFILE_AMENDMENT_REQUEST_TRANSACTION_LOG_URL = (
  uuid: string,
  apiPathParams: ApiPathParam
) => {
  const tParams = formAPIPageable(apiPathParams);
  return `${USER_BASE_URL}/admin/profile-amendment-requests/transaction-log/${uuid}${tParams}`;
};
export const GET_PROFILE_AMENDMENT_REQUEST_FILE_CONFIGS_URL = `${USER_BASE_URL}/candidate/profile-amendment-file-configs`;

export const PUT_ADD_ADDITIONAL_DOCUMENTS_PROFILE_AMENDMENT_REQUEST_URL = (uuid: string) =>
  `${USER_BASE_URL}/profile-amendment-requests/${uuid}/request-files`;

export const GET_MY_INFO_CONSENT_FORM_URL = `${USER_BASE_URL}/mi/consent-url`;

export const GET_MIMS_STATUS_URL = `${USER_BASE_URL}/mims/status/CP`;

export const PUT_SET_ACCOUNT_EXPIRY_DATE = `${USER_BASE_URL}/set-account-expiry-date`;
// =============================================================================
// Candidate
// =============================================================================
const CANDIDATE_BASE_URL = '/candidate/api';

export const GET_ADDRESS_DETAILS_URL = (postcode: string) =>
  `${
    import.meta.env.VITE_APP_ONE_MAP_API_DOMAIN
  }/api/common/elastic/search?searchVal=${postcode}&getAddrDetails=Y&returnGeom=N`;

export const GET_GROUP_EXAM_REGISTRATION_TEMPLATE_URL = (uuid: string, examType?: ExamType) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/download-registration-templates/${examType}`;
export const GET_GROUP_EXAM_REGISTRATION_SUMMARY_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/registration-summary`;
export const POST_GROUP_EXAM_REGISTRATION_UPLOAD_PRESIGNED_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/attached-file`;
export const POST_GROUP_EXAM_REGISTRATION = `${CANDIDATE_BASE_URL}/group-exam-registrations`;
export const POST_GROUP_EXAM_REGISTRATION_TOKEN = (token: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations?token=${token}`;
export const PUT_GROUP_EXAM_REGISTRATION_START_FILE_PROCESSING = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/start-processing`;
export const PUT_GROUP_EXAM_REGISTRATION_STOP_FILE_PROCESSING = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/stop-processing`;
export const GET_GROUP_EXAM_REGISTRATION_CHECK_ELIGIBILITY = (
  examType: ExamType,
  token?: string | null
) =>
  token
    ? `${CANDIDATE_BASE_URL}/group-exam-registrations/check-eligibility?examType=${examType}&token=${token}`
    : `${CANDIDATE_BASE_URL}/group-exam-registrations/check-eligibility?examType=${examType}`;
export const GET_EXAM_TYPE_URL = `${CANDIDATE_BASE_URL}/exam-types`;
export const POST_GROUP_EXAM_REGISTRATION_REVIEW = (uuid: string, apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/review${tparams}`;
};
export const POST_GROUP_EXAM_REGISTRATION_SUMMARY = (uuid: string, apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}${tparams}`;
};
export const POST_GROUP_EXAM_REGISTRATION_RETRIEVE_CANDIDATES = (
  uuid: string,
  apiPathParams: ApiPathParam
) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/candidates-registration-details${tparams}`;
};

export const GET_GROUP_EXAM_REGISTRATION_FEE_DETAILS = (uuid: string, examRegUuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/exam-registrations/${examRegUuid}`;
export const PUT_GROUP_EXAM_REGISTRATION_REMOVE_REGISTRATION = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/remove-exam-registrations`;

export const GET_GROUP_EXAM_REGISTRATIONS_URL = `${CANDIDATE_BASE_URL}/group-exam-registrations`;
export const GET_DOWNLOAD_ERROR_FILE_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/download-error-file`;

export const POST_GROUP_EXAM_REGISTRATION_PAYMENT = `${CANDIDATE_BASE_URL}/group-exam-registrations/confirm-and-pay`;
export const GET_GROUP_EXAM_REGISTRATION_RECEIPT_DETAILS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/registration-receipt`;
export const POST_GROUP_EXAM_REGISTRATION_SUMMARY_PDF_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/download-group-registration`;
export const POST_GROUP_EXAM_REGISTRATION_INDIVIDUAL_PAYMENT_LINK_URL = (
  groupExamRegUuid: string,
  individualExamRegUuid: string
) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${groupExamRegUuid}/exam-registrations/${individualExamRegUuid}/send-payment-link-email`;

export const GET_GROUP_EXAM_REGISTRATION_VERIFICATION_SLIP_PDF_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-exam-registrations/${uuid}/download-verification-slip`;

export const POST_BLACKLISTED_CANDIDATE_SEARCH_URL = (params: ApiPathParam) => {
  const pathParams = formAPIPageable(params);
  return `${CANDIDATE_BASE_URL}/blacklisted-candidates/search${pathParams}`;
};
export const POST_BLACKLISTED_CANDIDATE_URL = `${CANDIDATE_BASE_URL}/blacklisted-candidates`;
export const DELETE_BLACKLISTED_CANDIDATE_URL = `${CANDIDATE_BASE_URL}/blacklisted-candidates`;

export const PUT_REGISTRATION_PARTICULARS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/exam-registrations/${uuid}/update-profile`;

export const GET_ENABLED_MEDICAL_CONDITIONS_URL = `${CANDIDATE_BASE_URL}/admin/access-arrangements/enabled-medical-conditions`;
export const PUT_DISABLE_MEDICAL_CONDITIONS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/admin/access-arrangements/medical-conditions/${uuid}`;
export const PUT_ENABLE_MEDICAL_CONDITIONS_URL = `${CANDIDATE_BASE_URL}/admin/access-arrangements/medical-conditions`;
export const POST_IEXAM_MEDICAL_CONDITIONS_URL = `${CANDIDATE_BASE_URL}/admin/access-arrangements/medical-conditions/retrieve`;
export const GET_DROPDOWN_MEDICAL_CONDITIONS_URL = `${CANDIDATE_BASE_URL}/admin/access-arrangements/dropdown-medical-conditions`;

export const GET_ENABLED_REQUEST_TYPES_URL = (params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `${CANDIDATE_BASE_URL}/admin/access-arrangements/enabled-request-types${tparams}`;
};
export const PUT_DISABLE_REQUEST_TYPES_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/admin/access-arrangements/request-types/${uuid}`;
export const GET_DROPDOWN_REQUEST_TYPES_URL = `${CANDIDATE_BASE_URL}/admin/access-arrangements/dropdown-request-types`;
export const POST_IEXAM_REQUEST_TYPES_URL = `${CANDIDATE_BASE_URL}/admin/access-arrangements/request-types/retrieve`;
export const PUT_ENABLE_REQUEST_TYPES_URL = `${CANDIDATE_BASE_URL}/admin/access-arrangements/request-types`;
export const GET_ARRANGEMENT_OUTCOME_PDF = (params: string) =>
  `${CANDIDATE_BASE_URL}/access-arrangements/${params}/download-access-arrangements-outcome`;

export const POST_TRANSACTION_LOG_URL = `${CANDIDATE_BASE_URL}/audits`;
export const GET_PAYMENT_STATUS_URL = `${CANDIDATE_BASE_URL}/payment-status`;

export const GET_REGISTRATIONS_EXAM_LEVELS_URL = (nationalType: string, userType: string) =>
  `${CANDIDATE_BASE_URL}/admin/registration-exam-levels/${nationalType}?userType=${userType}`;

export const POST_SEND_UNIQUE_LINK_EMAIL_URL = `${CANDIDATE_BASE_URL}/admin/registration-unique-links/send-email`;
export const POST_VERIFY_UNIQUE_LINK_URL = `${CANDIDATE_BASE_URL}/registration-unique-links/verify`;
export const POST_VERIFY_CANDIDATE_URL = `${CANDIDATE_BASE_URL}/candidate/self-creation-validate`;
export const POST_ADMIN_VERIFY_CANDIDATE_URL = `${CANDIDATE_BASE_URL}/admin/candidate-creation-validate`;
export const POST_CREATE_CANDIDATE_NEW_URL = `${CANDIDATE_BASE_URL}/user/candidates`;

export const POST_GROUP_AMENDMENT_CHECK_ELIGIBILITY_URL = `${CANDIDATE_BASE_URL}/amendment/check-eligibility`;

export const POST_GROUP_AMENDMENT_SEARCH_URL = (params: ApiPathParam) => {
  const pathParams = formAPIPageable(params);
  return `${CANDIDATE_BASE_URL}/amendments/search${pathParams}`;
};

export const POST_SEARCH_CANDIDATE_GROUP_AMENDMENT_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/amendment/candidates/search${tparams}`;
};

export const POST_SEARCH_CANDIDATE_ENTRY_PROOF_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/entry-proofs/search${tparams}`;
};

export const POST_DOWNLOAD_ENTRY_PROOF_URL = `${CANDIDATE_BASE_URL}/entry-proofs/download`;

export const POST_SUBJECT_AMENDMENT_PAYMENT_LINK_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/amendment/${uuid}/send-payment-link-email`;

export const POST_COORDINATOR_REQUEST_LISTING_URL = (params: ApiPathParam) => {
  const tparams = formAPIPageWithoutSort(params);
  return `${CANDIDATE_BASE_URL}/access-arrangements/search${tparams}`;
};

export const POST_COORDINATOR_SELECT_CANDIDATE_URL = (params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `${CANDIDATE_BASE_URL}/access-arrangements/candidates/search${tparams}`;
};

export const POST_CREATE_GROUP_AMENDMENT_URL = `${CANDIDATE_BASE_URL}/amendment`;

export const POST_ACCESS_ARRANGEMENT_AMENDMENT = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/access-arrangements/${uuid}/amendment`;

export const GET_DOWNLOAD_ENTRY_PROOF_URL = (uuid: string, registrationType: string) =>
  `${CANDIDATE_BASE_URL}/entry-proofs/${uuid}/download-entry-proof?type=${registrationType}`;

export const GET_COORDINATOR_EXAM_LEVELS_URL = `${CANDIDATE_BASE_URL}/exam-levels/coordinator`;

export const GET_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_URL = `${CANDIDATE_BASE_URL}/special-considerations`;

export const GET_CANDIDATE_SELECTED_SPECIAL_CONSIDERATION_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${uuid}`;

export const PUT_CREATE_SPECIAL_CONSIDERATION_AMENDMENT_DRAFT_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${uuid}/amendment`;

export const POST_CREATE_SPECIAL_CONSIDERATION_NEW_APPLICATION_URL = `${CANDIDATE_BASE_URL}/special-considerations`;

export const DELETE_CANDIDATE_SPECIAL_CONSIDERATION_LISTING_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${uuid}`;

export const GET_EXAM_LEVELS_URL = `${CANDIDATE_BASE_URL}/exam-levels`;

export const GET_EXAM_SERIES_URL = `${CANDIDATE_BASE_URL}/exam-series`;

export const POST_SPECIAL_CONSIDERATION_CHECK_ELIGIBILITY_URL = `${CANDIDATE_BASE_URL}/special-considerations/check-eligibility`;

export const POST_ADD_SUBJECT_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${uuid}/request-details`;

export const PUT_SUBJECT_URL = (requestUuid: string, uuid: string) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${requestUuid}/request-details/${uuid}`;

export const DELETE_SPECIAL_CONSIDERATION_SUBJECT = (requestUuid: string, detailUuid: string) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${requestUuid}/request-details/${detailUuid}`;

export const GET_UPLOADED_FILE_INFO = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${uuid}/attached-files`;

export const GET_LIST_SUBJECTS_URL = (uuid: string, page: number, size: number) =>
  `${CANDIDATE_BASE_URL}/special-considerations/${uuid}/request-details/subjects?page=${page}&size=${size}`;

export const POST_ATTACH_FILE_SC = `${CANDIDATE_BASE_URL}/application-attached-files`;

export const GET_ADMISSION_YEARS_URL = `${CANDIDATE_BASE_URL}/exam-configuration/years`;

export const GET_ADMISSION_LEVEL_VACANCIES_URL = (year: number, uuid: string) =>
  `${CANDIDATE_BASE_URL}/admission-level-vacancies?year=${year}&examGroupLevel=${uuid}`;

export const GET_UNUSED_EXAM_LEVELS_URL = (year: number, uuid: string) =>
  `${CANDIDATE_BASE_URL}/admission-level-vacancies/unused-levels?year=${year}&examGroupLevel=${uuid}`;

export const POST_ADMISSION_LEVEL_VACANCIES_URL = `${CANDIDATE_BASE_URL}/admission-level-vacancies`;

export const DELETE_ADMISSION_LEVEL_VACANCIES_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/admission-level-vacancies/${uuid}`;

export const POST_PAY_NOW_PROXY_DETAILS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/exam-registrations/${uuid}/paynow-proxy`;

export const GET_UPCOMING_SUBJECT_PAPER_URL = `${CANDIDATE_BASE_URL}/exam-registrations/upcoming-subject-paper`;

export const GET_GSC_DOWNLOAD_TEMPLATE_URL = (groupScType: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/download-template/${groupScType}`;
export const GET_GSC_REQUEST_SUMMARY_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/request-summary`;
export const POST_GSC_UPLOAD_PRESIGNED_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/files`;
export const PUT_GSC_START_FILE_PROCESSING_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/start-processing`;
export const PUT_GSC_STOP_FILE_PROCESSING_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/stop-processing`;
export const PUT_GSC_REUPLOAD_FILE_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/remove-ranking-details`;
export const GET_GSC_DOWNLOAD_ERROR_FILE_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/download-error-file`;

export const GET_EXAM_CONFIGURATION_EXAM_TYPE_URL = `${CANDIDATE_BASE_URL}/exam-configuration/exam-type`;

export const POST_CANDIDATE_HISTORIES_SEARCH_URL = (uuid: string, apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/candidate-histories/${uuid}/search${tparams}`;
};
export const GET_CANDIDATE_HISTORIES_DOWNLOAD_TEMPLATE_URL = `${CANDIDATE_BASE_URL}/candidate-histories/download-template`;

export const PUT_CANDIDATE_HISTORIES_ATTACH_FILE_URL = `${CANDIDATE_BASE_URL}/candidate-histories/attach-file`;
export const PUT_CANDIDATE_HISTORIES_START_PROCESSING_URL = `${CANDIDATE_BASE_URL}/candidate-histories/start-processing`;
export const GET_FILE_BULK_PROCESSING_STATUS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/bulk-processing-status/${uuid}`;

export const GET_EXAM_CONFIGURATION_FEATURE_TYPE_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/exam-configuration/feature-type/${uuid}`;

export const GET_LAST_UPDATED_INFO_URL = (year: number, uuid: string) =>
  `${CANDIDATE_BASE_URL}/admission-level-vacancies/last-updated-info?year=${year}&examGroupLevel=${uuid}`;
export const POST_GSC_REQUEST_DETAIL_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/request-details`;
export const GET_GSC_REVIEW_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/review`;
export const GET_GSC_INDIVIDUAL_RANKING_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/individual-ranking`;
export const POST_GSC_GROUP_RANKING_URL = (uuid: string, apiPathParam: ApiPathParam) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/group-ranking${formAPIPageable(
    apiPathParam
  )}`;
export const GET_GSC_SUMMARY_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/summary`;

export const PUT_GSC_SUBMIT_REQUEST_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}`;
export const GET_GSC_DRAFT_SAVED_DATE_TIME_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/draft-saved-date-time`;

export const POST_GSC_CHECK_ELIGIBILITY_URL = `${CANDIDATE_BASE_URL}/group-special-considerations`;

export const DELETE_GSC_LISTING_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}`;

export const GET_GSC_CHECK_EXISTING_DRAFT_URL = (groupScType: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/check-existing-draft/${groupScType}`;

export const GET_GSC_UPLOADED_FILE_INFO_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/attached-files`;

export const POST_GSC_LISTING_URL = (params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `${CANDIDATE_BASE_URL}/group-special-considerations/search${tparams}`;
};

export const POST_EXAM_FEE_LISTING_URL = `${CANDIDATE_BASE_URL}/exam-fees/search`;
export const POST_EXAM_FEE_ADMISSION_LEVEL_URL = `${CANDIDATE_BASE_URL}/exam-fees/admission-levels`;
export const POST_EXAM_FEE_URL = `${CANDIDATE_BASE_URL}/exam-fees`;
export const PUT_EXAM_FEE_URL = (uuid: string) => `${CANDIDATE_BASE_URL}/exam-fees/${uuid}`;
export const DELETE_EXAM_FEE_URL = (uuid: string) => `${CANDIDATE_BASE_URL}/exam-fees/${uuid}`;

// Valid CEQ Test Date Paths
export const FETCH_VALID_CEQ_TEST_DATE_LISTING_URL = (
  examTypeUuid: string,
  admissionYear: number
) =>
  `${CANDIDATE_BASE_URL}/valid-ceq-test-date/search?examType=${examTypeUuid}&year=${admissionYear}`;
export const POST_CREATE_VALID_CEQ_TEST_DATES_URL = `${CANDIDATE_BASE_URL}/valid-ceq-test-date/dates`;
export const POST_UPDATE_VALID_CEQ_TEST_DATES_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/valid-ceq-test-date/dates/${uuid}`;
export const POST_DELETE_VALID_CEQ_TEST_DATES_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/valid-ceq-test-date/dates/${uuid}`;
export const FETCH_VALID_CEQ_TEST_DATE_URL = (examTypeUuid: string, registrationUuid: string) =>
  `${CANDIDATE_BASE_URL}/valid-ceq-test-date/dates/search?examType=${examTypeUuid}&registrationUuid=${registrationUuid}`;

export const GET_APPLICATION_FILES_CONFIG_URL = (applicationType: string) =>
  `${CANDIDATE_BASE_URL}/application-files-configs/${applicationType}`;

export const GET_APPLICATION_FILE_INFORMATION_URL = (fileKey: string) =>
  `${CANDIDATE_BASE_URL}/application-files/${fileKey}/information`;

export const GET_PARENT_DETAIL_TYPES = `${CANDIDATE_BASE_URL}/parent-detail-types`;

export const GET_USER_CITIZEN_SHIPS = `${CANDIDATE_BASE_URL}/user-citizenships`;

export const GET_WORK_PASS_TYPES_URL = (type: Type) =>
  `${CANDIDATE_BASE_URL}/work-pass-types?type=${type}`;

export const POST_SUBMIT_PARENT_PARTICULARS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/parent-particulars`;

export const GET_GSC_CONTINUE_APPLICATION_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/continue-application`;

export const PUT_AMEND_SUBMIT_REQUEST_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-special-considerations/${uuid}/amendment`;

export const GET_NON_NATIONAL_UPLOADED_FILE_INFO = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/attached-files`;

export const GET_NON_NATIONAL_INCOMPLETE_DETAILS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/incomplete-details`;

export const PUT_CANDIDATE_PROFILE_DETAILS_FOR_OPS_ADMIN_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/candidates/${uuid}`;

export const POST_NON_NATIONAL_SEARCH_URL = (params: any) =>
  `${CANDIDATE_BASE_URL}/non-national-result/search?size=${params.size}&page=${params.page}`;

export const GET_NON_NATIONAL_EXAM_GROUPS_URL = `${CANDIDATE_BASE_URL}/non-national-exam-groups`;

export const POST_NON_NATIONAL_GENERATE_RESULT = `${CANDIDATE_BASE_URL}/non-national-result/download-results`;

export const GET_EXEMPTION_RULES_DROPDOWN_URL = `${CANDIDATE_BASE_URL}/admin/exemption-rules`;

export const GET_UNIQUE_LINK_DETAILS_URL = (token?: string) =>
  `${CANDIDATE_BASE_URL}/admin/registration-unique-links/details/${token}`;

export const POST_INVALIDATE_UNIQUE_LINK = (token?: string) =>
  `${CANDIDATE_BASE_URL}/admin/access-links/${token}/invalidate`;

export const GET_UNIQUE_LINK_SUBJECT_DETAILS_URL = (subjectCode: string) =>
  `${CANDIDATE_BASE_URL}/unique-link-subjects/${subjectCode}/details`;

export const POST_UNIQUE_LINK_SUBJECTS_URL = (params: ApiPathParam) => {
  const tParams = formAPIPageable(params);
  return `${CANDIDATE_BASE_URL}/admin/unique-link-subjects/search${tParams}`;
};

export const GET_COORDINATOR_UNIQUE_LINK_COUNT_URL = (
  orgUuid: string,
  examLevel?: GenericExamLevel
) => `${CANDIDATE_BASE_URL}/admin/registration-unique-links/coordinators/${orgUuid}/${examLevel}`;

export const GET_UNIQUE_LINK_LISTING_URL = (
  coordinatorUuid: string | undefined,
  examLevel: GenericExamLevel | undefined
) => `${CANDIDATE_BASE_URL}/admin/registration-unique-links/${coordinatorUuid}/${examLevel}`;

export const GET_CANDIDATE_UNIQUE_LINK_COUNT_URL = (
  page: number | undefined,
  size: number | undefined
) => `${CANDIDATE_BASE_URL}/admin/registration-unique-links/candidate?page=${page}&size=${size}`;
// Unique Link Withdrawal

export const GET_WITHDRAWAL_UNIQUE_LINK_LISTING_URL = (
  coordinatorUuid: string | undefined,
  examLevel: GenericExamLevel | undefined
) => `${CANDIDATE_BASE_URL}/admin/withdrawal-unique-links/${coordinatorUuid}/${examLevel}`;

export const GET_WITHDRAWAL_UNIQUE_LINK_DETAILS_URL = (token?: string) =>
  `${CANDIDATE_BASE_URL}/admin/withdrawal-unique-links/details/${token}`;

export const GET_COORDINATOR_WITHDRAWAL_UNIQUE_LINK_COUNT_URL = (
  orgUuid: string,
  examLevel?: GenericExamLevel
) => `${CANDIDATE_BASE_URL}/admin/withdrawal-unique-links/coordinators/${orgUuid}/${examLevel}`;

export const GET_CANDIDATE_WITHDRAWAL_UNIQUE_LINK_COUNT_URL = (
  page: number | undefined,
  size: number | undefined
) => `${CANDIDATE_BASE_URL}/admin/withdrawal-unique-links/candidate?page=${page}&size=${size}`;

export const GET_SCHOOL_CANDIDATE_APPEAL_PAYMENT_WINDOW_STATUS_URL = `${CANDIDATE_BASE_URL}/school-candidate-payment/open-period`;

// =============================================================================
// Documents
// =============================================================================
const DOCUMENT_BASE_URL = '/document/api';

export const POST_ADMIN_PROFILE_PICTURE_UPLOAD_PRESIGNED_URL = `${DOCUMENT_BASE_URL}/profile-picture/generate-url`;

export const GET_DOCUMENT_UPLOAD_STATUS_URL = (fileKey: string) => {
  let route = '';
  if (fileKey) {
    route += `/${fileKey}`;
  }
  return `${DOCUMENT_BASE_URL}/s3/files${route}`;
};

// =============================================================================
// Financial
// =============================================================================
const FINANCIAL_BASE_URL = '/financial/api';

export const POST_VALIDATE_UNIQUE_LINK_URL = `${FINANCIAL_BASE_URL}/payments/validate-unique-link`;

// =============================================================================
// Registration
// =============================================================================
export const GET_BLACKLIST_CANDIDATE_TEMPLATE = `${CANDIDATE_BASE_URL}/blacklisted-candidates/download-template`;

export const PUT_START_FILE_BLACKLIST_PROCESSING = `${CANDIDATE_BASE_URL}/blacklisted-candidates/start-processing`;

export const PUT_ATTACH_FILE_BLACKLIST = `${CANDIDATE_BASE_URL}/blacklisted-candidates/attach-file`;

// =============================================================================
// Reporting
// =============================================================================
const REPORTING_BASE_URL = '/reporting/api';

export const POST_GENERATE_REPORT = `${REPORTING_BASE_URL}/registration-report/export`;

export const POST_NON_NATIONAL_GENERATE_REPORT = `${REPORTING_BASE_URL}/non-national-registration-report/export`;

export const POST_SPECIAL_CONSIDERATION_REPORT = `${REPORTING_BASE_URL}/special-consideration-report/export`;

export const POST_ACCESS_ARRANGEMENT_REPORT = `${REPORTING_BASE_URL}/access-arrangement-report/export`;

export const POST_NOTIFICATION_REPORT = `${REPORTING_BASE_URL}/notification-report/export`;

export const GET_CHECK_NOTIFICATION_REPORT_ELIGIBILITY = `${REPORTING_BASE_URL}/notification-report/check-eligibility`;

export const POST_AUDIT_REPORT_LISTING = `${REPORTING_BASE_URL}/audit-reports`;

export const POST_REVIEW_AUDIT_REPORT = (reportId: string) =>
  `${REPORTING_BASE_URL}/audit-reports/review/${reportId}`;

export const GET_CHECK_AUDIT_REPORT_ELIGIBILITY = `${REPORTING_BASE_URL}/audit-reports/check-eligibility`;

export const GET_AUDIT_REPORT = `${REPORTING_BASE_URL}/audit-reports`;

export const POST_ANNOUNCEMENT_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${REPORTING_BASE_URL}/admin/announcements/search${tparams}`;
};

export const GET_ADMIN_ANNOUNCEMENT_CONFIG_URL = (announcementType: string) =>
  `${REPORTING_BASE_URL}/admin/announcement-configs/${announcementType}`;
export const DELETE_ANNOUNCEMENT_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/announcements/${uuid}`;
export const POST_CREATE_ANNOUNCEMENT_URL = `${REPORTING_BASE_URL}/admin/announcements`;
export const GET_ANNOUNCEMENT_DETAILS_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/announcements/${uuid}`;
export const EDIT_ANNOUNCEMENT_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/announcements/${uuid}`;
export const GET_ANNOUNCEMENT_FEATURE_URL = `${REPORTING_BASE_URL}/admin/announcements-features`;

export const POST_ADMIN_APPLICATION_FILE_PRESIGNED_URL = `${REPORTING_BASE_URL}/admin/application-files`;
export const GET_ADMIN_APPLICATION_FILE_CONFIG_URL = (applicationType: string) =>
  `${REPORTING_BASE_URL}/admin/application-file-configs/${applicationType}`;
export const GET_ADMIN_APPLICATION_FILE_STATUS_URL = (applicationType: string, fileUuid: string) =>
  `${REPORTING_BASE_URL}/admin/application-file-status/${fileUuid}/${applicationType}`;
export const GET_ADMIN_DOWNLOAD_APPLICATION_FILE_PRESIGNED_URL = (fileUuid: string) =>
  `${REPORTING_BASE_URL}/admin/application-files/${fileUuid}/download-url`;
export const DELETE_ADMIN_APPLICATION_FILE_URL = (fileUuid: string) =>
  `${REPORTING_BASE_URL}/admin/application-files/${fileUuid}`;
export const GET_NON_PRIORITY_ANNOUNCEMENTS_URL = (
  announcementType: string,
  params: ApiPathParam
) => {
  const tparams = formAPIPageable(params);
  return `${REPORTING_BASE_URL}/announcements/${announcementType}${tparams}`;
};
export const GET_NOTIFICATION_FEATURE_URL = `${REPORTING_BASE_URL}/admin/notifications-features`;
export const POST_CREATE_NOTIFICATION_TEMPLATE_URL = `${REPORTING_BASE_URL}/admin/notification-templates`;
export const GET_NOTIFICATION_TEMPLATE_DETAILS_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/notification-templates/${uuid}`;
export const POST_CREATE_NOTIFICATION_URL = `${REPORTING_BASE_URL}/admin/notifications`;
export const GET_NOTIFICATION_DETAILS_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/notifications/${uuid}`;
export const GET_NOTIFICATION_VIEW_DETAILS_URL = (uuid: string, notificationType: string) =>
  `${REPORTING_BASE_URL}/admin/notifications/${notificationType}/${uuid}/view-details`;
export const EDIT_TEMPLATE_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/notification-templates/${uuid}`;
export const EDIT_NOTIFICATION_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/notifications/${uuid}`;
export const DELETE_NOTIFICATION_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/notifications/${uuid}`;
export const DELETE_NOTIFICATION_TEMPLATE_URL = (uuid: string) =>
  `${REPORTING_BASE_URL}/admin/notification-templates/${uuid}`;
export const POST_NOTIFICATION_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${REPORTING_BASE_URL}/admin/notifications/search${tparams}`;
};
export const POST_NOTIFICATION_SEARCH_RECIPIENT_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${REPORTING_BASE_URL}/admin/notifications/recipients/search${tparams}`;
};
export const POST_NOTIFICATION_TEMPLATE_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${REPORTING_BASE_URL}/admin/notification-templates/search${tparams}`;
};
// =============================================================================
// Audit Settings
// =============================================================================
export const GET_AUDIT_SETTINGS_REPORT_TYPES_URL = `${REPORTING_BASE_URL}/audit-setting/reportTypes`;
export const GET_RETRIEVE_AUDIT_SETTINGS_URL = (reportType: string) =>
  `${REPORTING_BASE_URL}/audit-setting/${reportType}`;
export const PUT_UPDATE_AUDIT_SETTINGS_URL = (reportType: string) =>
  `${REPORTING_BASE_URL}/audit-setting/${reportType}`;

// =============================================================================
// Non-national exam
// =============================================================================
export const GET_VALIDATE_NON_NATIONAL_EXAM_VACANCY = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/validate-vacancy`;
export const PUT_RESET_NON_NATIONAL_EXAM_VACANCY_PAYMENT_EXPIRY = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/reset-vacancy-payment-expiry`;
export const POST_NON_NATIONAL_EXAM_PAYMENT = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/confirm-and-pay`;
export const POST_NON_NATIONAL_EXAM_SCHOOLING_DETAIL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/exam-schooling-detail`;

export const POST_NON_NATIONAL_EXAM_CREATE_CANDIDATE = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/candidate-details`;

export const GET_NON_NATIONAL_EXAM_SUMMARY_PDF = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/download-registration`;

export const POST_GET_NON_NATIONAL_EXAM_CONFIRM_AND_PAY_DATA = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/candidate-profile-and-exam-registration`;

export const POST_SUBMIT_AEIS_ADDITIONAL_DETAILS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/aeis/${uuid}/additional-details`;

export const POST_SUBMIT_SPE_ADDITIONAL_DETAILS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/spe/${uuid}/additional-details`;

export const POST_PHOTO_UPLOAD_VALIDATE_URL = `${CANDIDATE_BASE_URL}/check-photo-upload`;

export const GET_NON_NATIONAL_EXAM_SUMMARY = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}`;

export const NON_NATIONAL_EXAM_APPLICATION_LISTING = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/admin/non-national-exam-registrations/search${tparams}`;
};

export const GET_INTENDED_RESIDENTIAL_AREA_URL = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/intended-residential-area`;

export const GET_INTENDED_RESIDENTIAL_ZONE_URL = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/intended-residential-zone`;

export const GET_NON_NATIONAL_APPLICATION_STATUS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/application-status`;

export const GET_NON_NATIONAL_APPLICATION_WITH_WITHDRAWAL_STATUS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/review-application-with-withdrawal`;

export const GET_NON_NATIONAL_ADMISSION_LEVEL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/admission-level`;

export const GET_NON_NATIONAL_SIBLING_EXAM_LEVEL = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/sibling-exam-levels`;

export const NON_NATIONAL_APPLICATION_STATUS_DROPDOWN = (allStatus: boolean) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/application-statuses?allStatus=${allStatus}`;

export const GET_NON_NATIONAL_APPLICATION_WITHDRAWAL_DROPDOWN = (allStatus: boolean) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/withdrawal-statuses?allStatus=${allStatus}`;

export const GET_MOTHER_TONGUE_LANGUAGES = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/mother-tongue-languages`;
export const GET_PASSPORT_DISABLED = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/passport-disabled`;

export const GET_NON_NATIONAL_EXAM_CANDIDATE_DETAILS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/candidate-details`;

export const PUT_NON_NATIONAL_APPLICATION_STATUS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/application-status`;

export const PUT_NON_NATIONAL_WITHDRAWAL_APPLICATION_STATUS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/withdrawal-status`;

export const GET_NON_NATIONAL_EXAM_SCHOOLING_DETAIL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/exam-schooling-detail`;

export const GET_NON_NATIONAL_EXAM_COUNTRY_URL = (isSpers: boolean) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/country?isSpers=${isSpers}`;

export const POST_VALIDATE_SUPPORTING_DOCUMENT_FILE_SIZE = `${CANDIDATE_BASE_URL}/check-supporting-documents`;

export const POST_VALIDATE_ADDITIONAL_DOCUMENT_FILE_SIZE = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/${uuid}/validate-additional-documents`;

export const GET_NON_NATIONAL_EXAM_RECEIPT_DETAILS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/exam-registrations/${uuid}/registration-receipt`;

export const GET_ADMIN_AUDIT_LOG = (
  uuid: string,
  page: number | undefined,
  size: number | undefined
) =>
  `${CANDIDATE_BASE_URL}/admin/non-national-exam-registrations/${uuid}/admin-audit-logs/search?page=${page}&size=${size}`;

export const GET_NON_NATIONAL_EXAM_TYPE_URL = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/exam-type`;

export const GET_AEIS_ADDITIONAL_DETAILS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/aeis/${uuid}/additional-details`;

export const GET_SPE_ADDITIONAL_DETAILS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-registrations/spe/${uuid}/additional-details`;

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_INSTRUCTION_URL = `${CANDIDATE_BASE_URL}/non-national-exam-registrations/existing-registration`;

export const POST_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_URL = `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals`;

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_DRAFT_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}/withdrawal-summary`;

export const PUT_NON_NATIONAL_UPDATE_WITHDRAWAL_DETAILS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}`;

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_REVIEW_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}/withdrawal-review`;

export const PUT_NON_NATIONAL_EXAM_WITHDRAWAL_CONFIRM_WITHDRAWAL_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}/confirm-withdrawal`;

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_ACKNOWLEDGEMENT_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}/withdrawal-acknowledgement`;

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_SUMMARY_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}`;

export const GET_NON_NATIONAL_EXAM_WITHDRAWAL_DOWNLOAD_SUMMARY_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}/download-withdrawal`;

export const GET_NON_NATIONAL_SUBMITTED_EXAM_WITHDRAWAL_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/non-national-exam-withdrawals/${uuid}/submitted-withdrawal`;

// =============================================================================
// Resit Registration
// =============================================================================
export const POST_CREATE_RESIT_REGISTRATION = (token?: string) =>
  formAPIToken(`${CANDIDATE_BASE_URL}/resit-registrations`, token);
export const PUT_RESIT_REGISTRATION_REVIEW = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/resit-registrations/${uuid}/candidate-profile-and-resit-registration`;
export const GET_RESIT_REGISTRATION_REVIEW = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/resit-registrations/${uuid}/candidate-profile-and-resit-registration`;
export const POST_RESIT_CONFIRM_AND_PAY = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/resit-registrations/${uuid}/confirm-and-pay`;
export const POST_RESIT_CHECK_ELIGIBILITY = `${CANDIDATE_BASE_URL}/resit-registrations/check-eligibility`;
export const GET_RESIT_SUBJECTS = (token?: string) =>
  formAPIToken(`${CANDIDATE_BASE_URL}/resit-registrations/subjects`, token);
export const GET_RESIT_EXAM_LEVELS = (token?: string) =>
  formAPIToken(`${CANDIDATE_BASE_URL}/resit-registrations/exam-levels`, token);
export const GET_CHECK_REGISTRATION_STATUS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/resit-registrations/${uuid}/registration-status-check`;

// =============================================================================
// Group Resit Registration
// =============================================================================
export const POST_CREATE_GROUP_RESIT_REGISTRATION = (token?: string) =>
  formAPIToken(`${CANDIDATE_BASE_URL}/group-resit-registrations`, token);
export const POST_GROUP_RESIT_REGISTRATION_START_PROCESSING = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-resit-registrations/${uuid}/start-processing`;
export const GET_GROUP_RESIT_REGISTRATION_FEE_PROCESSING_STATUS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-resit-registrations/${uuid}/fee-processing-status`;
export const GET_GROUP_RESIT_REGISTRATION_REVIEW = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-resit-registrations/${uuid}/review`;
export const GET_GROUP_RESIT_REGISTRATION_PROFILES_REGISTRATIONS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-resit-registrations/${uuid}/candidate-profiles-and-resit-registrations`;
export const POST_GROUP_RESIT_REGISTRATION_CONFIRM_AND_PAY = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/group-resit-registrations/${uuid}/confirm-and-pay`;

// =============================================================================
// Online Tutorials
// =============================================================================
export const GET_EXAM_LEVEL_AND_RESOURCE_TYPES = `${CANDIDATE_BASE_URL}/online-tutorials/exam-levels-and-resource-types`;
export const GET_DOCUMENT_DOWNLOAD = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/online-tutorials/resources/${uuid}?content-disposition=INLINE`;
export const GET_DOCUMENT_DOWNLOAD_AS_ATTACHMENT = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/online-tutorials/resources/${uuid}?content-disposition=ATTACHMENT`;
export const GET_RESOURCE_FILE_CONFIG = `${CANDIDATE_BASE_URL}/online-tutorials/file-config`;
export const POST_TUTORIALS_ATTACHED_FILE = `${CANDIDATE_BASE_URL}/online-tutorials/attached-file`;
export const POST_ADD_RESOURCE = `${CANDIDATE_BASE_URL}/online-tutorials`;
export const PUT_EDIT_RESOURCE = (uuid: string) => `${CANDIDATE_BASE_URL}/online-tutorials/${uuid}`;
export const GET_RESOURCE = (uuid: string) => `${CANDIDATE_BASE_URL}/online-tutorials/${uuid}`;

export const POST_ONLINE_TUTORIALS_LISTING = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/online-tutorials/search${tparams}`;
};

export const DELETE_ONLINE_TUTORIALS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/online-tutorials/${uuid}`;

// =============================================================================
// Appeal Registration
// =============================================================================
export const POST_CHECK_ELIGIBILITY_APPEAL_REGISTRATION = `${CANDIDATE_BASE_URL}/admin/appeal-registrations/check-eligibility`;
export const GET_CHECK_ACCESS_APPEAL_REGISTRATION = `${CANDIDATE_BASE_URL}/admin/appeal-registrations/check-access`;
export const POST_COORDINATOR_SEARCH_ADMIN_APPEAL = `${CANDIDATE_BASE_URL}/admin/appeal-registrations/search-coordinator`;
export const GET_COORDINATOR_APPEAL_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/appeal-registrations/search${tparams}`;
};
export const GET_COORDINATOR_APPEAL_EXAM_LEVEL_URL = `${CANDIDATE_BASE_URL}/appeal-registrations/exam-levels`;
export const POST_COORDINATOR_APPEAL_CHECK_ELIGIBILITY_URL = `${CANDIDATE_BASE_URL}/appeal-registrations/check-eligibility`;
export const POST_COORDINATOR_APPEAL_SELECT_CANDIDATE_LISTING_URL = (
  apiPathParams: ApiPathParam
) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${CANDIDATE_BASE_URL}/appeal-registrations/candidates/search${tparams}`;
};
export const POST_COORDINATOR_APPEAL_PROCEED_WITH_CANDIDATE_URL = `${CANDIDATE_BASE_URL}/appeal-registrations`;
export const GET_COORDINATOR_APPEAL_SELECT_SUBJECT_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/appeal-registrations/${uuid}/appeal-subjects`;
export const PUT_COORDINATOR_APPEAL_SAVE_UPDATE_SUBJECT_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/appeal-registrations/${uuid}`;
export const GET_COORDINATOR_APPEAL_REVIEW_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/appeal-registrations/${uuid}/review`;
export const GET_COORDINATOR_APPEAL_CONFIRM_AND_PAY_URL = `${CANDIDATE_BASE_URL}/appeal-registrations/confirm-and-pay`;
export const GET_COORDINATOR_APPEAL_PAYMENT_SUCCESS_DETAILS_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/appeal-registrations/${uuid}/payment-success-details`;
export const GET_COORDINATOR_APPEAL_SUMMARY_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/appeal-registrations/receipt/summary/${uuid}`;
export const GET_APPEAL_OUTCOME_URL = (fileKey: string) =>
  `${CANDIDATE_BASE_URL}/appeal/outcome/download/${fileKey}`;

export const POST_COORDINATOR_APPEAL_SEND_PAYMENT_LINK_URL = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/appeal-registration/${uuid}/send-payment-link-email`;

// =============================================================================
// Payment Link
// =============================================================================
export const POST_VALIDATE_PAYMENT_TOKEN = (token: string) =>
  `${CANDIDATE_BASE_URL}/payment-link/validate-payment-token?token=${token}`;

// =============================================================================
// Non-national Results
// =============================================================================
export const PUT_START_IMPORT_RESULT_FILE_PROCESSING = () =>
  `${CANDIDATE_BASE_URL}/non-national-result/start-processing`;
export const POST_NON_NATIONAL_RESULTS_IMPORT_PRESIGNED_URL = () =>
  `${CANDIDATE_BASE_URL}/non-national-result/attached-file`;

export const GET_NON_NATIONAL_RESULTS_FILES_CONFIG_URL = () =>
  `${CANDIDATE_BASE_URL}/non-national-result/file-config`;

// =============================================================================
// Data Archival
// =============================================================================
export const POST_DATA_ARCHIVAL_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${USER_BASE_URL}/admin/data-archival/search${tparams}`;
};
export const GET_DATA_ARCHIVAL_FILTER_YEAR_URL = `${REPORTING_BASE_URL}/admin/data-archival/year`;
export const GET_DATA_ARCHIVAL_FILTER_ARCHIVAL_LEVEL_URL = `${REPORTING_BASE_URL}/admin/data-archival/data-level`;
export const GET_DATA_ARCHIVAL_TEMPLATE_URL = `${REPORTING_BASE_URL}/admin/data-archival/template`;
export const POST_CREATE_DATA_ARCHIVAL_URL = `${USER_BASE_URL}/admin/data-archival`;
export const GET_DATA_ARCHIVAL_DETAIL_URL = (uuid: string) =>
  `${USER_BASE_URL}/admin/data-archival/${uuid}`;

// =============================================================================
// Transaction
// =============================================================================
export const POST_TRANSACTION_CANDIDATE_LISTING_URL = (params: ApiPathParam) => {
  const tParams = formAPIPageable(params);
  return `${CANDIDATE_BASE_URL}/payment-details/transaction/candidates${tParams}`;
};

export const GET_TRANSACTION_DETAILS_LISTING_URL = (candidateUuid: string) =>
  `${CANDIDATE_BASE_URL}/payment-details/transaction?candidateUuid=${candidateUuid}`;
// =============================================================================
// Data Archival Report
// =============================================================================
export const POST_DATA_ARCHIVAL_REPORT_LISTING_URL = (apiPathParams: ApiPathParam) => {
  const tparams = formAPIPageable(apiPathParams);
  return `${REPORTING_BASE_URL}/admin/data-archival-report/search${tparams}`;
};
export const GET_DATA_ARCHIVAL_REPORT_FILTER_ARCHIVAL_LEVEL_URL = `${REPORTING_BASE_URL}/admin/data-archival-report/data-level`;
export const POST_DATA_ARCHIVAL_REPORT_DOWNLOAD_URL = `${REPORTING_BASE_URL}/admin/data-archival-report/resources`;

// =============================================================================
// Job Status Report
// =============================================================================

export const GET_JOB_STATUS_REPORT_NAME_URL = `${REPORTING_BASE_URL}/admin/job-name`;
export const POST_JOB_STATUS_REPORTS_MUTATION_URL = (apiPathParams: ApiPathParam) => {
  const params = formAPIPageable(apiPathParams);
  return `${REPORTING_BASE_URL}/admin/job-status-report/search${params}`;
};
export const PUT_JOB_STATUS_REPORTS_RESET_RETRY_URL = `${REPORTING_BASE_URL}/attempts/reset`;
export const POST_JOB_STATUS_REPORT_EMAIL_URL = `${REPORTING_BASE_URL}/admin/job-status-report/emails`;

export const EXPORT_JOB_STATUS_REPORT_URL = `${REPORTING_BASE_URL}/admin/job-status-report/export`;
// =============================================================================
// Record Status
// =============================================================================
export const GET_RECORD_STATUS_URL = `${REPORTING_BASE_URL}/admin/record-statuses`;

// =============================================================================
// Unlock account
// =============================================================================
export const POST_UNLOCK_ACCOUNT_URL = `${USER_BASE_URL}/user/unlock-account`;
// =============================================================================
// School Candidate Payment
// =============================================================================
export const POST_RETRIEVE_SCHOOL_CANDIDATE_PAYMENT_DETAILS = `${CANDIDATE_BASE_URL}/school-candidate-payment/get-payment-details`;
export const POST_RETRIEVE_SCHOOL_CANDIDATE_APPEAL_REGISTRATION = `${CANDIDATE_BASE_URL}/school-candidate-payment/appeal/search`;
export const GET_SCHOOLS_FOR_SCHOOL_CANDIDATE_PAYMENT = `${USER_BASE_URL}/organisations/school-candidate-payment`;
export const GET_SCHOOL_CANDIDATE_PAYMENT_ACCESS = (organisationUuid: string) =>
  `${USER_BASE_URL}/access/school-candidate-payment/${organisationUuid}`;
export const POST_SCHOOL_CANDIDATE_CONFIRM_AND_PAY = `${CANDIDATE_BASE_URL}/school-candidate-payment/confirm-and-pay`;
export const POST_SCHOOL_CANDIDATE_APPEAL_CONFIRM_AND_PAY = `${CANDIDATE_BASE_URL}/school-candidate-payment/appeal/confirm-and-pay`;
export const GET_SCHOOL_CANDIDATE_PAYMENT_RECEIPT = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/school-candidate-payment/${uuid}/payment-success-details`;
export const POST_SCHOOL_CANDIDATE_PAYMENT_PAYNOW_PROXY_DETAILS = (uuid: string) =>
  `${CANDIDATE_BASE_URL}/school-candidate-payment/${uuid}/paynow-proxy`;
